import React, { useEffect, useState, useCallback } from "react";
import {
    useLoadCandidateAppsQuery,
    useLoadAppRuningTasksQuery
} from "../../store/candidateApiSlice";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
import { getFieldData, getFormatedNumber } from "../../../Services/appService";
import { getCurrentUser } from "../../store/auth";
import { getAppTasks, getCandidateApps, loadAppRuningTasks, loadCandidateApps } from "../../store/candidate";
import { useDispatch, useSelector } from "react-redux";
import TimerPopup from "../../../Components/TimerPopup";
import AppMessages from "../../../Components/AppMessages";
import { setCurrentPageTitle, setCurrentRoute } from "../../store/layoutUI";
import { OverlayTrigger, Popover } from "react-bootstrap";

const ONBOARDING_STATUS_STYLES = {
    card: {
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        borderRadius: "0",
        border: "1px solid rgba(226, 232, 240, 0.95)",
        backgroundColor: "#ffffff",
        boxShadow: "0 10px 30px rgba(15, 23, 42, 0.05)",
        overflow: "hidden"
    },
    cardHeader: {
        padding: "18px 22px",
        borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
        background: "#ffffff"
    },
    headerRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "16px",
        flexWrap: "wrap"
    },
    headerCopy: {
        minWidth: "240px",
        flex: "1 1 420px"
    },
    headerActions: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end"
    },
    title: {
        fontSize: "18px",
        fontWeight: 600,
        color: "#0f172a",
        lineHeight: 1.25,
        margin: 0
    },
    titleRow: {
        display: "flex",
        alignItems: "center",
        gap: "12px"
    },
    titleIcon: {
        width: "34px",
        height: "34px",
        borderRadius: "0",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
        color: "#2563eb",
        fontSize: "14px",
        border: "1px solid rgba(191, 219, 254, 0.9)",
        boxShadow: "0 4px 12px rgba(37, 99, 235, 0.06)",
        flexShrink: 0
    },
    titleText: {
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        minWidth: 0
    },
    subtitle: {
        fontSize: "12px",
        color: "#64748b",
        margin: 0,
        fontWeight: 600
    },
    cardBody: {
        padding: "0"
    },
    utilityRow: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "12px",
        flexWrap: "wrap",
        marginBottom: "14px"
    },
    refreshButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "0",
        border: "1px solid #cbd5e1",
        background: "#ffffff",
        color: "#334155",
        padding: "9px 18px",
        fontSize: "13px",
        fontWeight: 600,
        boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
        cursor: "pointer",
        transition: "all 0.2s ease"
    },
    tableWrap: {
        overflowX: "auto",
        backgroundColor: "#ffffff"
    },
    table: {
        width: "100%",
        marginBottom: 0,
        borderCollapse: "separate",
        borderSpacing: 0,
        fontSize: "13px",
        color: "#334155"
    },
    tableHeadCell: {
        borderTop: "none",
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#64748b",
        background: "#f8fafc",
        borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
        padding: "14px 16px"
    },
    rowCell: {
        verticalAlign: "top",
        padding: "16px 18px",
        borderTop: "1px solid rgba(241, 245, 249, 1)",
        background: "#ffffff",
        fontWeight: 600
    },
    idValue: {
        fontSize: "13.5px",
        fontWeight: 600,
        color: "#0f172a",
        display: "flex",
        alignItems: "center",
        gap: "6px"
    },
    idIcon: {
        color: "#94a3b8",
        fontSize: "11px"
    },
    dateContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "2px"
    },
    datePrimary: {
        fontSize: "13px",
        fontWeight: 600,
        color: "#0f172a",
        display: "flex",
        alignItems: "center",
        gap: "6px"
    },
    dateSecondary: {
        fontSize: "11.5px",
        color: "#64748b",
        fontWeight: 600
    },
    personCard: {
        display: "flex",
        alignItems: "flex-start",
        gap: "10px",
        maxWidth: "250px"
    },
    personAvatar: {
        width: "32px",
        height: "32px",
        borderRadius: "0",
        background: "#eff6ff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#2563eb",
        fontSize: "12px",
        fontWeight: 600,
        flexShrink: 0,
        border: "1px solid rgba(191, 219, 254, 0.9)"
    },
    personInfo: {
        display: "flex",
        flexDirection: "column",
        gap: "3px",
        minWidth: 0
    },
    personName: {
        fontSize: "13px",
        fontWeight: 600,
        color: "#0f172a",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    },
    personMeta: {
        fontSize: "11.5px",
        lineHeight: 1.4,
        color: "#64748b",
        display: "flex",
        alignItems: "center",
        gap: "6px",
        fontWeight: 600
    },
    actionStack: {
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        alignItems: "flex-start"
    },
    viewAction: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "0",
        border: "1px solid rgba(191, 219, 254, 0.9)",
        background: "#eff6ff",
        color: "#2563eb",
        padding: "9px 18px",
        fontSize: "13px",
        fontWeight: 600,
        boxShadow: "0 2px 6px rgba(37, 99, 235, 0.04)",
        cursor: "pointer",
        transition: "all 0.2s ease",
        whiteSpace: "nowrap"
    },
    editAction: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "0",
        border: "1px solid #cbd5e1",
        background: "#ffffff",
        color: "#334155",
        padding: "9px 18px",
        fontSize: "13px",
        fontWeight: 600,
        boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
        cursor: "pointer",
        transition: "all 0.2s ease",
        whiteSpace: "nowrap"
    },
    statusPillBase: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "6px 14px",
        borderRadius: "0",
        fontSize: "12.5px",
        fontWeight: 600,
        border: "1px solid transparent",
        whiteSpace: "nowrap"
    },
    unreadBadge: {
        position: "absolute",
        top: "-5px",
        right: "-5px",
        minWidth: "18px",
        height: "18px",
        borderRadius: "0",
        background: "#ef4444",
        color: "#ffffff",
        fontSize: "10px",
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "2px solid #ffffff",
        padding: "0 4px"
    },
    noteButton: {
        border: "1px solid rgba(191, 219, 254, 0.9)",
        background: "#eff6ff",
        color: "#2563eb",
        padding: "7px 14px",
        fontSize: "12.5px",
        fontWeight: 600,
        borderRadius: "0",
        display: "inline-flex",
        alignItems: "center",
        gap: "6px"
    }
};

export default function OnboardingStatus() {

    const usrType = localStorage.getItem("userType");
    const [entityType, setEntityType] = useState("");
    const [appTasklist, setAppTasklist] = useState([]);
    const [appSubmitStatus, setAppSubmitStatus] = useState(false);
    const [timerShowHide, setTimerShowHide] = useState(false);
    const [msgShowHide, setMsgShowHide] = useState(false);
    const [wfId, setWfId] = useState(0);
    const [currentApp, setCurrentApp] = useState("");

    const dispatch = useDispatch();
    const currentUser = getCurrentUser();
    const navigate = useNavigate();

    let usrId = currentUser?.id;
    if (currentUser?.linkUser) usrId = currentUser.linkUser;

    const { data: candidateAppsSelector = [] } = useLoadCandidateAppsQuery(usrId, { skip: !usrId });
    const { data: appTasksSelector = [] } = useLoadAppRuningTasksQuery(
        { wfId, userId: usrId },
        { skip: !wfId || !usrId }
    );

    const route = [
        { name: "Task Management", url: "" },
        { name: "Onboarding", url: "" },
    ];
    const route1 = [
        { name: "Contract Management", url: "" },
        { name: "Onboarding", url: "" },
    ];

    let appType = "Onboarding";
    if (usrType === "candidate")
        appType = "Onboarding";

    let count = entityType !== "C2C Basis" ? "6" : "5";

    if (usrType !== "candidate")
        count = "5";


    useEffect(() => {
        dispatch(setCurrentPageTitle(`STEP-${count} : ${appType}`));
        dispatch(setCurrentRoute(usrType === "candidate" ? route : route1));
    }, [dispatch, count, appType, usrType, route, route1]);

    useEffect(() => {
        if (candidateAppsSelector.length > 0) {
            const mainWorkflow = candidateAppsSelector.filter(x => x.workflowType === 1);
            if (mainWorkflow.length > 0) {
                const wf = mainWorkflow[0];
                setWfId(wf.oldWorkflowId);
            }
        }
    }, [candidateAppsSelector]);

    useEffect(() => {
        if (appTasksSelector.length > 0) {
            const filterTasks = appTasksSelector.filter(x => x.taskType === 1 && x.wiid > 0
                && (x.wfPhase === "Review" || x.wfPhase === "Approved" || x.wfPhase === "Rejected"));
            let firstAppTasks = [];
            if (filterTasks.length > 0) {
                firstAppTasks = [filterTasks[filterTasks.length - 1]];
                setAppTasklist(firstAppTasks);
                setAppSubmitStatus(filterTasks[0].appSubmit);
            }
        }
    }, [appTasksSelector]);

    const handleViewAppSummary = (item, type) => {
        navigate("/ApplicationSummary", { state: { task: item, viewType: type } });
    }

    const handleRefresh = () => {
        let usrId = currentUser.id;
        if (currentUser.linkUser) usrId = currentUser.linkUser;
        if (usrId > 0) dispatch(loadCandidateApps(usrId, { subscribe: false, forceRefetch: true }));
        if (wfId > 0 && usrId > 0) dispatch(loadAppRuningTasks(wfId, usrId, { subscribe: false, forceRefetch: true }));
    };

    const handleCurrentTask = () => {
        // const { data: workflowTask } = await http.get(
        //     config.GetWorkflowTask + wiid
        //   );
        //   if (workflowTask.formId > 0) {
        //     if (workflowTask.formType === "CF") {
        //       this.props.history.push({
        //         pathname: "/" + workflowTask.formName,
        //         state: { workflowTask },
        //       });
        //     } else {
        //       this.props.history.push({
        //         pathname: "/DynamicForm",
        //         state: { workflowTask },
        //       });
        //     }
        //   }
    }

    const handleTimerModalShowHide = () => {
        setTimerShowHide(!timerShowHide);
    };

    const handleMsgShowHide = (app) => {
        setMsgShowHide(!msgShowHide);
        setCurrentApp(app);
    };

    function formatCustomDate(dateString) {
        const date = new Date(dateString);
        const day = date.getDate();
        const suffix = ["th", "st", "nd", "rd"][(day % 10 > 3 || [11, 12, 13].includes(day)) ? 0 : day % 10];

        return date.toLocaleString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            hour12: true
        }).replace(/\b\d{1,2}\b/, day + suffix);
    }

    const getPopover = (notes) => {
        const popover = (
            <Popover id="popover-basic">
                <Popover.Title as="h4">Notification</Popover.Title>
                <Popover.Content>{notes}</Popover.Content>
            </Popover>
        );
        return (
            <OverlayTrigger trigger="click" placement="top" overlay={popover}>
                <button className="btn btn-sm" style={ONBOARDING_STATUS_STYLES.noteButton}>Notification</button>
            </OverlayTrigger>
        );
    };

    const getStatusPillStyle = (wfPhase) => {
        if (wfPhase === "Approved") {
            return {
                ...ONBOARDING_STATUS_STYLES.statusPillBase,
                color: "#166534",
                backgroundColor: "#f0fdf4",
                borderColor: "rgba(187, 247, 208, 1)"
            };
        }

        if (wfPhase === "Rejected") {
            return {
                ...ONBOARDING_STATUS_STYLES.statusPillBase,
                color: "#b91c1c",
                backgroundColor: "#fef2f2",
                borderColor: "rgba(254, 202, 202, 1)"
            };
        }

        return {
            ...ONBOARDING_STATUS_STYLES.statusPillBase,
            color: "#92400e",
            backgroundColor: "#fffbeb",
            borderColor: "rgba(253, 230, 138, 1)"
        };
    };

    const renderReviewerDetails = (name, role, extra, email, contact, time) => {
        const initials = name ? name.split(" ").map(n => n[0]).join("").toUpperCase().substring(0, 2) : "??";
        return (
            <div style={ONBOARDING_STATUS_STYLES.personCard}>
                <div style={ONBOARDING_STATUS_STYLES.personAvatar}>{initials}</div>
                <div style={ONBOARDING_STATUS_STYLES.personInfo}>
                    {name && <div style={ONBOARDING_STATUS_STYLES.personName}>{name.toUpperCase()}</div>}
                    {(role || extra) && (
                        <div style={ONBOARDING_STATUS_STYLES.personMeta}>
                            <i className="fa fa-briefcase" style={{ fontSize: "10px", opacity: 0.6 }} aria-hidden="true"></i>
                            <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                {role} {extra}
                            </span>
                        </div>
                    )}
                    {email && (
                        <div style={ONBOARDING_STATUS_STYLES.personMeta}>
                            <i className="fa fa-envelope-o" style={{ fontSize: "10px", opacity: 0.6 }} aria-hidden="true"></i>
                            <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{email}</span>
                        </div>
                    )}
                    {contact && (
                        <div style={ONBOARDING_STATUS_STYLES.personMeta}>
                            <i className="fa fa-phone" style={{ fontSize: "10px", opacity: 0.6 }} aria-hidden="true"></i>
                            {getFormatedNumber(contact)}
                        </div>
                    )}
                    {time && (
                        <div style={{ ...ONBOARDING_STATUS_STYLES.personMeta, color: "#2563eb", fontWeight: 600, marginTop: "2px" }}>
                            <i className="fa fa-calendar-check-o" style={{ fontSize: "10px" }} aria-hidden="true"></i>
                            {formatCustomDate(time)}
                        </div>
                    )}
                </div>
            </div>
        );
    };


    return <React.Fragment>

        <div className="mt-2 form-group">
            <style>{`
                .onboarding-status-table tbody tr:hover td {
                    background-color: #f8fbff !important;
                }

                @media (max-width: 991.98px) {
                    .onboarding-status-table {
                        min-width: 1100px;
                    }
                }
            `}</style>
            <div className="card shadow-none border-1" style={ONBOARDING_STATUS_STYLES.card}>
                <div className="card-header border-1" style={ONBOARDING_STATUS_STYLES.cardHeader}>
                    <div style={ONBOARDING_STATUS_STYLES.headerRow}>
                        <div style={ONBOARDING_STATUS_STYLES.headerCopy}>
                            <div style={ONBOARDING_STATUS_STYLES.titleRow}>
                                <span style={ONBOARDING_STATUS_STYLES.titleIcon}>
                                    <i className="fa fa-clipboard" aria-hidden="true"></i>
                                </span>
                                <div style={ONBOARDING_STATUS_STYLES.titleText}>
                                    <h2 style={ONBOARDING_STATUS_STYLES.title}>Check Onboarding Status</h2>
                                    <p style={ONBOARDING_STATUS_STYLES.subtitle}>
                                        Review latest onboarding decision, assigned reviewers, notifications, and conversation history.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div style={ONBOARDING_STATUS_STYLES.headerActions}>
                            <button
                                className="btn btn-sm"
                                style={ONBOARDING_STATUS_STYLES.refreshButton}
                                onClick={handleRefresh}
                            >
                                <i className="fa fa-refresh" aria-hidden="true"></i>
                                Refresh
                            </button>
                        </div>
                    </div>
                </div>
                <div className="card-body border-1" style={ONBOARDING_STATUS_STYLES.cardBody}>
                    <div className="table-responsive" style={ONBOARDING_STATUS_STYLES.tableWrap}>
                        <table className="table align-items-center mb-0 onboarding-status-table" style={ONBOARDING_STATUS_STYLES.table}>
                            <thead>
                                <tr>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>ID</th>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>Submission Details</th>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>Actions</th>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>Reviewer Assigned</th>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>Reviewer Re-Assigned</th>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>Status</th>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>Communications</th>
                                </tr>
                            </thead>
                            <tbody>
                                {appTasklist.map((item, key) =>
                                    <tr key={item.wiid || key}>
                                        <td style={ONBOARDING_STATUS_STYLES.rowCell}>
                                            <div style={ONBOARDING_STATUS_STYLES.idValue}>
                                                <i className="fa fa-hashtag" style={ONBOARDING_STATUS_STYLES.idIcon} aria-hidden="true"></i>
                                                {item.ciid}
                                            </div>
                                        </td>
                                        <td style={ONBOARDING_STATUS_STYLES.rowCell}>
                                            <div style={ONBOARDING_STATUS_STYLES.dateContainer}>
                                                <div style={ONBOARDING_STATUS_STYLES.datePrimary}>
                                                    <i className="fa fa-calendar" style={{ color: "#2563eb", fontSize: "11px" }} aria-hidden="true"></i>
                                                    <Moment format="MMM Do, YYYY">
                                                        {item.startDateTime}
                                                    </Moment>
                                                </div>
                                                <div style={ONBOARDING_STATUS_STYLES.dateSecondary}>
                                                    <i className="fa fa-clock-o mr-1" style={{ color: "#94a3b8", fontSize: "11px" }} aria-hidden="true"></i>
                                                    <Moment format="h:mm a">
                                                        {item.startDateTime}
                                                    </Moment>
                                                </div>
                                            </div>
                                        </td>
                                        <td style={ONBOARDING_STATUS_STYLES.rowCell}>
                                            <div style={ONBOARDING_STATUS_STYLES.actionStack}>
                                                <button
                                                    onClick={() => handleViewAppSummary(item, "view")}
                                                    className="btn btn-sm"
                                                    style={ONBOARDING_STATUS_STYLES.viewAction}
                                                >
                                                    <i className="fa fa-eye" aria-hidden="true"></i>
                                                    View Form
                                                </button>
                                                <button
                                                    onClick={() => handleViewAppSummary(item, "edit")}
                                                    className="btn btn-sm"
                                                    style={ONBOARDING_STATUS_STYLES.editAction}
                                                >
                                                    <i className="fa fa-pencil" aria-hidden="true"></i>
                                                    Edit Details
                                                </button>
                                            </div>
                                        </td>
                                        <td style={ONBOARDING_STATUS_STYLES.rowCell}>
                                            {item.reassignById > 0 ? <>
                                                {renderReviewerDetails(
                                                    item.reassignByName,
                                                    item.reassignByRole,
                                                    item.reassignByRegistrationType !== "WP" &&
                                                    item.reassignByRegistrationType !== "PP" &&
                                                    item.reassignByRegistrationType,
                                                    item.reassignByEmail,
                                                    item.reassignByContact
                                                )}
                                            </> : <>
                                                {item.performerId !== parseInt(currentUser.id) && <>
                                                    {renderReviewerDetails(
                                                        item.performer,
                                                        item.role,
                                                        `${item.partner || ""} ${item.registrationType !== "WP" &&
                                                            item.registrationType !== "PP" &&
                                                            item.registrationType ? item.registrationType : ""}`.trim(),
                                                        item.email,
                                                        item.contact
                                                    )}
                                                </>}
                                            </>}
                                        </td>
                                        <td style={ONBOARDING_STATUS_STYLES.rowCell}>
                                            {item.reassignById > 0 && item.performerId !== parseInt(currentUser.id) && <>
                                                {renderReviewerDetails(
                                                    item.performer,
                                                    item.role,
                                                    `${item.partner || ""} ${item.registrationType !== "WP" &&
                                                        item.registrationType !== "PP" &&
                                                        item.registrationType ? item.registrationType : ""}`.trim(),
                                                    item.email,
                                                    item.contact,
                                                    item.reassignDateTime
                                                )}
                                            </>}
                                        </td>
                                        <td style={{ ...ONBOARDING_STATUS_STYLES.rowCell, whiteSpace: "pre-wrap" }}>
                                            <div style={{ display: "flex", flexDirection: "column", gap: "8px", alignItems: "flex-start" }}>
                                                {item.performerId === parseInt(currentUser.id) ?
                                                    <button
                                                        className="btn btn-sm"
                                                        style={{ ...ONBOARDING_STATUS_STYLES.viewAction, borderColor: "#3b82f6", color: "#2563eb", background: "rgba(59, 130, 246, 0.05)" }}
                                                        onClick={() => handleCurrentTask(item.wiid)}
                                                    >
                                                        <i className="fa fa-play-circle" aria-hidden="true"></i>
                                                        {item.wfPhase}
                                                    </button> : (
                                                        <span style={getStatusPillStyle(item.wfPhase)}>
                                                            {item.wfPhase === "Approved" ? (
                                                                <i className="fa fa-check-circle" style={{ fontSize: "14px" }} aria-hidden="true"></i>
                                                            ) : item.wfPhase === "Rejected" ? (
                                                                <i className="fa fa-times-circle" style={{ fontSize: "14px" }} aria-hidden="true"></i>
                                                            ) : (
                                                                <i className="fa fa-clock-o" style={{ fontSize: "14px" }} aria-hidden="true"></i>
                                                            )}
                                                            {item.wfPhase}
                                                        </span>
                                                    )}
                                                {usrType !== "candidate" && (
                                                    <div style={{ marginTop: "2px" }}>
                                                        {getPopover(getFieldData(item.stateData, "contractdocuments", "Notification_Notes"))}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                        <td style={ONBOARDING_STATUS_STYLES.rowCell}>
                                            {item.taskDoneStatus !== 0 && item.wfPhase !== "Application" && (
                                                <button
                                                    className="btn btn-sm"
                                                    style={{ ...ONBOARDING_STATUS_STYLES.viewAction, position: "relative", paddingRight: "16px" }}
                                                    onClick={() => handleMsgShowHide(item)}
                                                >
                                                    <i className="fa fa-comments-o" style={{ color: "#4f46e5" }} aria-hidden="true"></i>
                                                    View History
                                                    {item.unreadMessage > 0 && (
                                                        <span style={ONBOARDING_STATUS_STYLES.unreadBadge}>
                                                            {item.unreadMessage}
                                                        </span>
                                                    )}
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        {timerShowHide && <TimerPopup
            timerShowHide={timerShowHide}
            handleTimerModalShowHide={handleTimerModalShowHide}
        ></TimerPopup>}
        {msgShowHide &&
            <AppMessages
                msgShowHide={msgShowHide}
                handleMsgShowHide={handleMsgShowHide}
                currentApp={currentApp}
                workflowId={wfId}
            ></AppMessages>}
    </React.Fragment>
}
